import React											from 'react';

import {QuantitySelectProps}							from './interface';

import img_less											from '../../images/icon/less-square.svg';
import img_plus											from '../../images/icon/plus-square.svg';
import img_cross										from '../../images/icon/cross-arraw.svg';

import './QuantitySelect.css';
import Icon from '../Icon';
import ft_cssVar from '../../functions/getCssVar';


function QuantitySelect(props: QuantitySelectProps): JSX.Element {
	return (
		<div className={'quantitySelectMainContainer'}>
			<Icon
				iconSize={18}
				iconWidth={22}
				onClick={(props.value === 1 && !props.delete) ? undefined : () => props.onClickLess(props.value - 1)}
				icon={(props.value === 1 && props.delete) ? img_cross : img_less}
				iconColor={(props.value === 1 && !props.delete) ? ft_cssVar('gray-300') : undefined}
			/>
			<span>{props.value}</span>
			<Icon
				iconSize={18}
				icon={img_plus}
				onClick={() => props.onClickPlus(props.value + 1)}
			/>
		</div>
	);
}

export default QuantitySelect;